// Keep required API timezone values defined even when browser detection fails.
// UTC is explicit and does not guess the user's location from an offset.
export default function getBrowserTimeZone() {
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (typeof timeZone === 'string' && timeZone.trim()) {
      return timeZone;
    }
  } catch (error) {
    // Some browser environments cannot resolve the system timezone.
  }
  return 'UTC';
}
